import React, { useEffect } from 'react'
import './loader.scss'

const Loader = () => {

	useEffect(() => {
		window.scroll(0, 0);
	}, [])


	return (
		<div className='t-loader' data-testid="loader">
			<div className="lds-ring">
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	)
}

export default Loader